import React from "react";

function WhatWeDo() {
  return (
    <section className="bg-[#eaebec] w-full py-12">
      <div className="w-full max-w-[1280px] px-4 2xl:px-0 mx-auto">
        {/* Section Header */}
        <div className="flex items-center w-full mx-auto">
          <div>
            <h2 className="text-3xl md:text-4xl my-2">What We Do</h2>
            <div className="border-b-4 border-green-600 w-36 md:w-40" />
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-col md:flex-row justify-between items-start w-full gap-8">
          {/* Description Section */}
          <div className="w-full md:w-[55%] mt-2">
            <h3 className="w-[85%] text-base md:text-lg">
              <strong className="text-lg md:text-xl">We </strong>
              offer psychological counseling services to individuals who could be
              facing the following but not limited to:
            </h3>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li><h4 className="text-base md:text-lg">Life transition challenges</h4></li>
              <li><h4 className="text-base md:text-lg">Relationship issues</h4></li>
              <li><h4 className="text-base md:text-lg">Stress or depression</h4></li>
              <li><h4 className="text-base md:text-lg">Anxiety or any other Disorder</h4></li>
              <li><h4 className="text-base md:text-lg">Those who have various addictions</h4></li>
              <li><h4 className="text-base md:text-lg">Suicidal ideation</h4></li>
              <li><h4 className="text-base md:text-lg">Marriage and family issues</h4></li>
              <li><h4 className="text-base md:text-lg">Loss and grief</h4></li>
              <li><h4 className="text-base md:text-lg">Trauma (physical, emotional or sexual)</h4></li>
            </ul>
          </div>

          {/* Other Services Section */}
          <div className="w-full md:w-[40%]">
            <div className="flex mb-2">
              <div className="text-left">
                <h3 className="text-lg md:text-xl">Other Services</h3>
                <div className="border-b-4 border-green-600 w-16" />
              </div>
            </div>
            <p className="text-base md:text-lg font-normal mt-2">
              Other additional intensive services that we offer include:
            </p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li><h4 className="text-base md:text-lg">Psychoeducation</h4></li>
              <li><h4 className="text-base md:text-lg">Critical incidence debriefing</h4></li>
              <li><h4 className="text-base md:text-lg">Motivational talks</h4></li>
              <li><h4 className="text-base md:text-lg">Mentorship for Adolescents and youth</h4></li>
              <li><h4 className="text-base md:text-lg">Supervision for counselors</h4></li>
              <li><h4 className="text-base md:text-lg">Psychological assessments</h4></li>
              <li><h4 className="text-base md:text-lg">Career screening and guidance</h4></li>
            </ul>

          </div>
        </div>

        {/* Groups Section */}
        <div className="w-full mx-auto my-8">
          <h3 className="text-base md:text-lg">
            <strong>We</strong> offer the above Consultancy services to various groups in:
          </h3>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li><h4 className="text-base md:text-lg">Churches</h4></li>
            <li><h4 className="text-base md:text-lg">Schools</h4></li>
            <li><h4 className="text-base md:text-lg">Institutions of Learning</h4></li>
            <li><h4 className="text-base md:text-lg">Workplaces</h4></li>
            <li><h4 className="text-base md:text-lg">Community Level</h4></li>
            <li><h4 className="text-base md:text-lg">Colleges and Universities</h4></li>
          </ul>

        </div>
      </div>
    </section>
  );
}

export default WhatWeDo;
